import { useMutation } from '@apollo/client'
import {
  BulkUpdateItemsAndStepsDocument,
  GetProcessDetailDocument,
} from 'generated/resources/graphql'

import { BulkUpdateItem } from './useBulkUpdateItems'
import { BulkUpdateSteps } from './useBulkUpdateSteps'

export const useBulkUpdateItemsAndSteps = () => {
  const [executeMutation, { loading }] = useMutation(BulkUpdateItemsAndStepsDocument)

  const bulkUpdateItemsAndSteps = async (
    items: BulkUpdateItem[],
    steps: BulkUpdateSteps[],
    processId: number
  ) => {
    const { data, errors } = await executeMutation({
      variables: {
        items,
        steps,
      },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: GetProcessDetailDocument,
          variables: {
            id: processId,
          },
        },
      ],
    })

    if (errors?.length || data?.processesMutations?.bulkUpdateProcessesItem?.errors.length) {
      throw (
        'Could not update step: ' +
        JSON.stringify([
          ...(errors || []),
          ...(data?.processesMutations?.bulkUpdateProcessesItem?.errors || []),
        ])
      )
    }
  }

  return {
    bulkUpdateItemsAndSteps,
    loading,
  }
}
